import '@/assets/reset.css'
import '@/assets/tooltip.css'
import '@/assets/simplebar.css'

import Vue from 'vue'
import App from './App.vue'

import _ from 'underscore'
import moment from 'moment'
import tooltip from 'v-tooltip'
import autosize from 'vue-textarea-autosize'

import store from './service/store'
import router from './service/router'
import api from './service/api'
import constants from './service/constants'
import pubsub from './service/pubsub'
import guard from './service/guard'
import util from './service/util'

import mixWindow from './mixin/window'
import mixServices from './mixin/services'
import mixShortcuts from './mixin/shortcuts'

Vue.config.productionTip = false

var requireComponentGlobal = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

var payload = JSON.parse(document.getElementById('app').getAttribute('data-payload').replace('&quote;', '"'))

store.commit('session/set', payload.session)
store.commit('data/set', payload.data)
store.commit('settings/set', payload.data.settings)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentConfig = requireComponentGlobal(filename)
	var componentName = 'app' + filename.replace(/\//g, '-').replace('.vue', '').replace('.', '').toLowerCase()

	Vue.component(
		componentName,
		componentConfig.default
	)

})

Vue.mixin(mixWindow)
Vue.mixin(mixServices)
Vue.mixin(mixShortcuts)

Vue.use(tooltip)
Vue.use(autosize)

Vue.filter('formatDate', function (value, format) {

	return (value) ? moment.unix(value).utc().format(format) : ''

})

Vue.filter('componentName', function (name) {

    return 'com-' + name.replace(/\//g, '-')

})

router.beforeEach(guard)

new Vue({
	_,
	moment,
	store,
	router,
	api,
	util,
	constants,
	pubsub,
	render: h => h(App),
	created: function() {

		pubsub.$emit('window.initiated')

	}
}).$mount('#app')